import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = { class: "progress-dial-v2" };
const _hoisted_2 = { class: "pdv2-top" };
const _hoisted_3 = {
    class: "pdv2-svg",
    viewBox: "0 0 70 70"
};
const _hoisted_4 = ["id", "x1", "y1", "x2", "y2"];
const _hoisted_5 = ["id", "x1", "y1", "x2", "y2"];
const _hoisted_6 = ["stop-color"];
const _hoisted_7 = ["stroke", "stroke-dasharray"];
const _hoisted_8 = ["stroke", "stroke-dasharray", "stroke-dashoffset"];
const _hoisted_9 = { class: "pdv2-ring-inner" };
const _hoisted_10 = ["src"];
const _hoisted_11 = { class: "pdv2-info" };
const _hoisted_12 = { class: "pdv2-title" };
const _hoisted_13 = { class: "pdv2-date-row" };
const _hoisted_14 = { class: "pdv2-date" };
const _hoisted_15 = { class: "pdv2-days" };
const _hoisted_16 = {
    key: 0,
    class: "pdv2-message"
};
const _hoisted_17 = ["src"];
const _hoisted_18 = ["innerHTML"];
import { ref, computed, onMounted, watch } from 'vue';
const R = 33;
export default /*@__PURE__*/ _defineComponent({
    __name: 'ProgressDialV2',
    props: {
        image: { default: '' },
        fromDate: {},
        toDate: {},
        title: { default: 'Renewal' },
        infoMessage: { default: '' },
        animationDuration: { default: 1500 }
    },
    setup(__props) {
        const CIRCUMFERENCE = 2 * Math.PI * R;
        const props = __props;
        const currentProgress = ref(0);
        const circumference = CIRCUMFERENCE;
        const gradientId = 'pdv2-' + Math.random().toString(36).substring(2, 11);
        const total = computed(() => {
            const from = new Date(props.fromDate);
            const to = new Date(props.toDate);
            return Math.round((to.getTime() - from.getTime()) / (1000 * 60 * 60 * 24));
        });
        const daysRemaining = computed(() => {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            const to = new Date(props.toDate);
            return Math.max(0, Math.round((to.getTime() - today.getTime()) / (1000 * 60 * 60 * 24)));
        });
        const targetProgress = computed(() => {
            if (total.value <= 0)
                return 0;
            return Math.max(0, Math.min(1, (total.value - daysRemaining.value) / total.value));
        });
        const formattedDate = computed(() => {
            const date = new Date(props.toDate);
            return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });
        });
        const halfArc = computed(() => {
            return (currentProgress.value * CIRCUMFERENCE) / 2;
        });
        const arcStart = computed(() => {
            return { x: 35 + R, y: 35 };
        });
        const arcMid = computed(() => {
            const angle = currentProgress.value * Math.PI;
            return {
                x: 35 + R * Math.cos(angle),
                y: 35 + R * Math.sin(angle)
            };
        });
        const endColour = computed(() => {
            return daysRemaining.value <= 30 ? '#9EA2D0' : '#E1C6C8';
        });
        const arcEnd = computed(() => {
            const angle = currentProgress.value * 2 * Math.PI;
            return {
                x: 35 + R * Math.cos(angle),
                y: 35 + R * Math.sin(angle)
            };
        });
        function animate() {
            currentProgress.value = 0;
            const startTime = performance.now();
            const target = targetProgress.value;
            const duration = props.animationDuration;
            const step = (currentTime) => {
                const elapsed = currentTime - startTime;
                const t = Math.min(elapsed / duration, 1);
                const eased = 1 - Math.pow(1 - t, 3);
                currentProgress.value = target * eased;
                if (t < 1) {
                    requestAnimationFrame(step);
                }
            };
            requestAnimationFrame(step);
        }
        onMounted(() => {
            animate();
        });
        watch(() => props.fromDate, () => { animate(); });
        watch(() => props.toDate, () => { animate(); });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", {
                        class: "pdv2-ring-wrapper",
                        onClick: animate
                    }, [
                        (_openBlock(), _createElementBlock("svg", _hoisted_3, [
                            _createElementVNode("defs", null, [
                                _createElementVNode("linearGradient", {
                                    id: gradientId + '-1',
                                    gradientUnits: "userSpaceOnUse",
                                    x1: arcStart.value.x,
                                    y1: arcStart.value.y,
                                    x2: arcMid.value.x,
                                    y2: arcMid.value.y
                                }, _cache[0] || (_cache[0] = [
                                    _createElementVNode("stop", {
                                        offset: "0%",
                                        "stop-color": "#FCE5D4"
                                    }, null, -1),
                                    _createElementVNode("stop", {
                                        offset: "100%",
                                        "stop-color": "#E1C6C8"
                                    }, null, -1)
                                ]), 8, _hoisted_4),
                                _createElementVNode("linearGradient", {
                                    id: gradientId + '-2',
                                    gradientUnits: "userSpaceOnUse",
                                    x1: arcMid.value.x,
                                    y1: arcMid.value.y,
                                    x2: arcEnd.value.x,
                                    y2: arcEnd.value.y
                                }, [
                                    _cache[1] || (_cache[1] = _createElementVNode("stop", {
                                        offset: "0%",
                                        "stop-color": "#E1C6C8"
                                    }, null, -1)),
                                    _createElementVNode("stop", {
                                        offset: "100%",
                                        "stop-color": endColour.value
                                    }, null, 8, _hoisted_6)
                                ], 8, _hoisted_5)
                            ]),
                            _cache[2] || (_cache[2] = _createElementVNode("circle", {
                                cx: "35",
                                cy: "35",
                                r: "33",
                                fill: "none",
                                stroke: "#F2F2F2",
                                "stroke-width": "3.8"
                            }, null, -1)),
                            (currentProgress.value > 0.005)
                                ? (_openBlock(), _createElementBlock("circle", {
                                    key: 0,
                                    cx: "35",
                                    cy: "35",
                                    r: "33",
                                    fill: "none",
                                    stroke: 'url(#' + gradientId + '-1)',
                                    "stroke-width": "3.8",
                                    "stroke-linecap": "round",
                                    "stroke-dasharray": halfArc.value + ' ' + _unref(circumference),
                                    "stroke-dashoffset": 0
                                }, null, 8, _hoisted_7))
                                : _createCommentVNode("", true),
                            (currentProgress.value > 0.005)
                                ? (_openBlock(), _createElementBlock("circle", {
                                    key: 1,
                                    cx: "35",
                                    cy: "35",
                                    r: "33",
                                    fill: "none",
                                    stroke: 'url(#' + gradientId + '-2)',
                                    "stroke-width": "3.8",
                                    "stroke-linecap": "round",
                                    "stroke-dasharray": halfArc.value + ' ' + _unref(circumference),
                                    "stroke-dashoffset": '-' + halfArc.value
                                }, null, 8, _hoisted_8))
                                : _createCommentVNode("", true)
                        ])),
                        _createElementVNode("div", _hoisted_9, [
                            (_ctx.image)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: _ctx.image,
                                    class: "pdv2-icon"
                                }, null, 8, _hoisted_10))
                                : _createCommentVNode("", true)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.title), 1),
                        _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("span", _hoisted_14, _toDisplayString(formattedDate.value), 1),
                            _createElementVNode("span", _hoisted_15, "in " + _toDisplayString(daysRemaining.value) + " days", 1)
                        ])
                    ])
                ]),
                (_ctx.infoMessage)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _createElementVNode("img", {
                            src: require('@/assets/info-16px.svg'),
                            class: "pdv2-message-icon"
                        }, null, 8, _hoisted_17),
                        _createElementVNode("span", {
                            class: "pdv2-message-text",
                            innerHTML: _ctx.infoMessage
                        }, null, 8, _hoisted_18)
                    ]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
